import { CardItemComponent } from './components/card-item/card-item.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertComponent } from './components/alert/alert.component';
import { GiftBagComponent } from './components/gift-bag/gift-bag.component';
import { ModalComponent } from './components/modal/modal.component';
import { ManagerCardComponent } from './components/manager-card/manager-card.component';
import { LoadingComponent } from './components/loading/loading.component';



@NgModule({
  declarations: [
    CardItemComponent,
    AlertComponent,
    GiftBagComponent,
    ModalComponent,
    ManagerCardComponent,
    LoadingComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CardItemComponent,
    AlertComponent,
    GiftBagComponent,
    ModalComponent,
    ManagerCardComponent,
    LoadingComponent
  ]
})
export class SharedModule { }
